import React from 'react'
import * as THREE from 'three'
import { useThree } from '@react-three/fiber'
import { Box, useCubeTexture } from '@react-three/drei'

export default function SkyBox({
    path = '/monster/imgs/desert/',
}) {
    const { scene } = useThree();

    scene.background = new THREE.CubeTextureLoader()
        .setPath(path)
        .load([
            'pos-x.png', 'neg-x.png',
            'pos-y.png', 'neg-y.png',
            'pos-z.png', 'neg-z.png'
        ]);

    return null;
}
